<script>
import { Pie } from 'vue-chartjs'

export default {
  name: 'AttendancePieChart',
  extends: Pie,
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      chartData: {
        labels: ['Present', 'Absent'],
        datasets: []
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  mounted() {
        this.renderChart(this.chartData, this.chartOptions)
    },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(newData) {
        const totalPresent = newData.reduce((sum, student) => sum + (student.present || 0), 0)
        const totalAbsent = newData.reduce((sum, student) => sum + (student.absent || 0), 0)

        this.chartData = {
          labels: ['Present', 'Absent'],
          datasets: [
            {
              data: [totalPresent, totalAbsent],
              backgroundColor: ['#4CAF50', '#FF5252'],
              hoverOffset: 10
            }
          ]
        }
      }
    }
  }
}
</script>
